import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Proptypes from 'prop-types';
import { makeStyles, Button, Tab, TabList, Tooltip } from '@fluentui/react-components';

import { Mode } from '@bingads-webui-react/app-layout-container';
import { DocumentMultiple20Regular, Home20Regular, Navigation16Regular } from '@fluentui/react-icons';

import { pathTabMap, tabPathMap, ICON_FILL_COLOR } from './constants';

const useStyles = makeStyles({
  pageMenuContainer: {
    transition: 'width 0.2s',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '8.5px',
  },
  toggleMenuButton: {
    height: '36px',
    marginLeft: '4px',
  },
});

const PageMenuComponent = ({
  changeLayout,
  mode,
}) => {
  const classes = useStyles();
  const { pathname: path } = useLocation();
  const navigate = useNavigate();

  const onToggleClick = useCallback(() => {
    if (mode === Mode.Expanded) changeLayout({ nav: { mode: Mode.Collapsed } });
    else changeLayout({ nav: { mode: Mode.Expanded } });
  }, [mode, changeLayout]);

  const renderTabs = useCallback(() => {
    if (mode === Mode.Collapsed) {
      return (
        <>
          <Tab icon={<Home20Regular />} value="home" aria-label="home-page" />
          <Tab icon={<DocumentMultiple20Regular />} value="api" aria-label="api-page" />
        </>
      );
    }
    return (
      <>
        <Tab icon={<Home20Regular />} value="home" aria-label="home-page">Home</Tab>
        <Tab icon={<DocumentMultiple20Regular />} value="api" aria-label="api-page">API</Tab>
      </>
    );
  }, [mode]);

  const onTabSelect = useCallback((ev, data) => {
    navigate(tabPathMap[data.value]);
  }, [navigate]);

  const selectedTab = pathTabMap[path] || 'unknown';

  return (
    <nav className={classes.pageMenuContainer}>
      <Tooltip content="Menu" relationship="label" positioning="after" hideDelay={0} showDelay={0}>
        <Button
          className={classes.toggleMenuButton}
          appearance="transparent"
          icon={<Navigation16Regular primaryFill={ICON_FILL_COLOR} />}
          onClick={onToggleClick}
          aria-label="menu"
          aria-expanded={mode === mode.isExpanded}
        />
      </Tooltip>
      <TabList vertical selectedValue={selectedTab} onTabSelect={onTabSelect}>
        {renderTabs()}
      </TabList>
    </nav>
  );
};

PageMenuComponent.propTypes = {
  changeLayout: Proptypes.func.isRequired,
  mode: Proptypes.string.isRequired,
};

export const PageMenu = PageMenuComponent;
